import { supabase } from '../lib/supabase';

export const realtimeService = {
  /**
   * Subscribe to consultation bookings changes (INSERT, UPDATE, DELETE)
   */
  subscribeToConsultationBookings(onInsert, onUpdate, onDelete) {
    const channel = supabase?.channel('consultation_bookings_changes')
      ?.on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'consultation_bookings'
        },
        (payload) => {
          if (onInsert) {
            onInsert(payload?.new);
          }
        }
      )
      ?.on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'consultation_bookings'
        },
        (payload) => {
          if (onUpdate) {
            onUpdate(payload?.new, payload?.old);
          }
        }
      )
      ?.on(
        'postgres_changes',
        {
          event: 'DELETE',
          schema: 'public',
          table: 'consultation_bookings'
        },
        (payload) => {
          if (onDelete) {
            onDelete(payload?.old);
          }
        }
      )
      ?.subscribe();

    return channel;
  },

  /**
   * Subscribe to conversion events (INSERT)
   */
  subscribeToConversionEvents(onInsert) {
    const channel = supabase?.channel('conversion_events_changes')
      ?.on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'conversion_events'
        },
        (payload) => {
          if (onInsert) {
            onInsert(payload?.new);
          }
        }
      )
      ?.subscribe();

    return channel;
  },

  /**
   * Subscribe to sales pipeline changes (INSERT, UPDATE)
   */
  subscribeToSalesPipeline(onInsert, onUpdate) {
    const channel = supabase?.channel('sales_pipeline_changes')
      ?.on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'sales_pipeline'
        },
        (payload) => {
          if (onInsert) {
            onInsert(payload?.new);
          }
        }
      )
      ?.on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'sales_pipeline'
        },
        (payload) => {
          if (onUpdate) {
            onUpdate(payload?.new, payload?.old);
          }
        }
      )
      ?.subscribe();

    return channel;
  },

  /**
   * Subscribe to lead scores updates (INSERT, UPDATE)
   */
  subscribeToLeadScores(onInsert, onUpdate) {
    const channel = supabase?.channel('lead_scores_changes')
      ?.on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'lead_scores'
        },
        (payload) => {
          if (onInsert) {
            onInsert(payload?.new);
          }
        }
      )
      ?.on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'lead_scores'
        },
        (payload) => {
          if (onUpdate) {
            onUpdate(payload?.new, payload?.old);
          }
        }
      )
      ?.subscribe();

    return channel;
  },

  /**
   * Unsubscribe from real-time updates
   */
  unsubscribe(channel) {
    if (channel) {
      supabase?.removeChannel(channel);
    }
  },

  /**
   * Unsubscribe from multiple channels
   */
  unsubscribeAll(channels) {
    if (channels && Array.isArray(channels)) {
      channels?.forEach(channel => {
        if (channel) {
          supabase?.removeChannel(channel);
        }
      });
    }
  }
};
